/** Firma estable de camera_ids para memos de tarjetas Shelly. */
export function cameraIdsSignature(ids: unknown): string {
  if (!Array.isArray(ids) || ids.length === 0) return '';
  return ids
    .map((x) => Number(x))
    .filter((n) => Number.isFinite(n))
    .join(',');
}

/**
 * True si cambió algo que afecta badges de la tarjeta
 * (PIN, auth, cámaras, timer, agenda).
 */
export function deviceBadgesChanged(prev: any, next: any): boolean {
  if (Boolean(prev?.pin_required) !== Boolean(next?.pin_required)) return true;
  if (Boolean(prev?.auth_required) !== Boolean(next?.auth_required)) return true;
  if (cameraIdsSignature(prev?.camera_ids) !== cameraIdsSignature(next?.camera_ids)) return true;
  if (JSON.stringify(prev?.timer_config ?? null) !== JSON.stringify(next?.timer_config ?? null)) return true;
  if (JSON.stringify(prev?.agenda_config ?? null) !== JSON.stringify(next?.agenda_config ?? null)) return true;
  return false;
}
